module.exports = __webpack_public_path__ + "img/compras_publicas_ouro.ff847ec6.png";